import * as types from "../actions/actionTypes"
import initialState from "./initialState";

export default function authReducer(state = initialState.auth, action) {
    switch (action.type) {
        case types.LOGIN_REQUEST:
            return action.auth;
            //return { ...state, auth: action.auth };
        case types.LOGIN_SUCCESS:
            return action.auth;
            //return { ...state, auth: action.auth };
        case types.LOGIN_FAILURE:
            return action.auth;
            //return { ...state, auth: action.auth };
        case types.LOGOUT_REQUEST:
            return action.auth;
            //return { ...state, auth: action.auth };
        case types.LOGOUT_SUCCESS:
            return action.auth;
            //return { ...state, auth: action.auth };
        case types.BEGIN_API_UNAUTHORISED:
            return Object.assign({},
                state,
                {
                    isAuthenticated: false
                });
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/authReducer.js